import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotify } from '@hotjar/hotsauce';
import { sessionsSettingsApi } from '@hotjar/webapp/features/Settings/api';

export const useEnableSessionCaptureConsent = () => {
  const { showToast } = useNotify();
  const { t } = useTranslation();

  const runEnableSessionCaptureConsent = useCallback(
    async (siteId: number, onSuccess: () => void) => {
      const response = await sessionsSettingsApi.post(siteId as number, 'update_session_settings', {
        session_capture_console_consent: true,
      });

      if (response.success) {
        showToast({
          text: t('common:player.console-tracking-enabled-success'),
          kind: 'success',
        });

        onSuccess();
        return;
      }

      showToast({
        text: t('common:player.console-tracking-enabled-error'),
        kind: 'danger',
      });
    },
    [showToast, t],
  );

  return runEnableSessionCaptureConsent;
};
